import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../type';

export const dataSelector = (state: RootState) => state.data;

export const isDataSelector = createSelector(dataSelector, (state) => state);
